(
    function (skyward, $, undefined)
    {
        skyward.staarfieldoverride = skyward.staarfieldoverride || {};
        
        var init = function (selector)
        {
            "use strict";
            var staarFieldOverrideWorkflowSelector, staarFieldOverrideDetailsSelector, recordTypeComboBox, eocTestVersion,
                workflowPrefix, eocPaperMultiselect, eocOnlineMultiselect, testSubjectEel, testVersionCombobox, starrSubmissionEel;

            staarFieldOverrideWorkflowSelector = $(selector).filter(".workflowContent");
            staarFieldOverrideDetailsSelector = $(selector).find("#editSTAARFieldOverrideTX");

            if (staarFieldOverrideWorkflowSelector.length > 0)
            {
                workflowPrefix = "STAARFieldOverrideTX.";
            }
            else if (staarFieldOverrideDetailsSelector.length > 0)
            {
                workflowPrefix = "";
            }
            else
            {
                return;
            }

            recordTypeComboBox = $('select[name="' + workflowPrefix + 'RecordTypeCode"]');
            skyward.staarfieldoverride.updateUIForRecordType(recordTypeComboBox, workflowPrefix);

            recordTypeComboBox.change(function ()
            {
                skyward.staarfieldoverride.updateUIForRecordType(recordTypeComboBox, workflowPrefix);
            });

            eocPaperMultiselect = $(".EndOfCourseCodesMultiSelectPaper");
            eocOnlineMultiselect = $(".EndOfCourseCodesMultiSelectOnline");
            eocTestVersion = $(".EndOfCourseCodesMultiSelectTestVersionEOC");

            if (eocPaperMultiselect && eocOnlineMultiselect)
            {
                eocPaperMultiselect.change(function ()
                {
                    skyward.staarfieldoverride.checkForDuplicateMultiselectItem(eocPaperMultiselect, eocOnlineMultiselect, true);
                });
                eocOnlineMultiselect.change(function ()
                {
                    skyward.staarfieldoverride.checkForDuplicateMultiselectItem(eocPaperMultiselect, eocOnlineMultiselect, false);
                });
            }

            testSubjectEel = $('input[name="' + workflowPrefix + 'StateSTAARTestSubjectTypeTXID"]');
            
            starrSubmissionEel = $('input[name="' + workflowPrefix + 'StateSTAARSubmissionTXID"]');
            starrSubmissionEel.change(function ()
            {
                skyward.staarfieldoverride.removeAllMultiselectItems(eocPaperMultiselect);
                skyward.staarfieldoverride.removeAllMultiselectItems(eocOnlineMultiselect);
                skyward.staarfieldoverride.removeAllMultiselectItems(eocTestVersion);
            });
        };
        
        skyward.staarfieldoverride.updateUIForRecordType = function (recordTypeComboBox, workflowPrefix)
        {
            var recordType, eocPaperMultiselect, eocOnlineMultiselect, eocTestVersion;

            recordType = recordTypeComboBox.find('option:selected').val();

            if (!recordType)
            {
                return;
            }

            if (workflowPrefix)
            {
                eocPaperMultiselect = $(".EndOfCourseCodesMultiSelectPaper");
                eocOnlineMultiselect = $(".EndOfCourseCodesMultiSelectOnline");
                eocTestVersion = $(".EndOfCourseCodesMultiSelectTestVersionEOC");
            }

            removeEOCCodeSelectionSection();

            function removeEOCCodeSelectionSection()
            {
                if (eocPaperMultiselect)
                {
                    skyward.staarfieldoverride.removeAllMultiselectItems(eocPaperMultiselect);
                }

                if (eocOnlineMultiselect)
                {
                    skyward.staarfieldoverride.removeAllMultiselectItems(eocOnlineMultiselect);
                }

                if (eocTestVersion)
                {
                    skyward.staarfieldoverride.removeAllMultiselectItems(eocOnlineMultiselect);
                }
            }
        };

        skyward.staarfieldoverride.checkForDuplicateMultiselectItem = function (eocPaperMultiselect, eocOnlineMultiselect, hasPaperChanged)
        {
            var paperNodes, onlineNodes;
            paperNodes = eocPaperMultiselect.find(".selectedItems ").find(".selectedItem ").prevAll(':not(.dummyTile)');
            onlineNodes = eocOnlineMultiselect.find(".selectedItems ").find(".selectedItem ").prevAll(':not(.dummyTile)');

            for (var i = 0; i < paperNodes.length; i++)
            {
                for (var j = 0; j < onlineNodes.length; j++)
                {
                    if ($(paperNodes[i]).attr("data-targetid") == $(onlineNodes[j]).attr("data-targetid"))
                    {
                        if (hasPaperChanged)
                        {
                            $(onlineNodes[j]).find(".selectedItem__removeIcon").click();
                            return;
                        }
                        else
                        {
                            $(paperNodes[i]).find(".selectedItem__removeIcon").click();
                            return;
                        }
                    }
                }
            }
        };

        skyward.staarfieldoverride.removeAllMultiselectItems = function (multiselectElement)
        {
            var selectNodes = multiselectElement.find(".selectedItems ").find(".selectedItem ").prevAll(':not(.dummyTile)');
            for (var i = 0; i < selectNodes.length; i++)
            {
                $(selectNodes[i]).find("selectedItem__removeIcon").click();
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);